import { useTranslation } from '../../../../providers/UIProvider';
import type { FormatterProps } from '../types/editor-config';
import { FormatterError } from './FormatterError';

/** Renders a boolean value as the translated Yes/No label, or `—` when nullish. */
export function BooleanFormatter({ value, errors }: FormatterProps) {
  const t = useTranslation('components.boolean');
  const text = value === true ? t('TRUE') : value === false ? t('FALSE') : '—';
  return (
    <span className='inline-flex flex-col gap-2xs items-start'>
      <span>{text}</span>
      <FormatterError issues={errors} />
    </span>
  );
}
